

<section class="bg-half-170 bg-light d-table w-100" id="home" style="background: url('assets/images/blog/breadcrumb.png');">
    <div class="container">
        <div class="row mt-5 justify-content-center">
            <!-- <div class="col-lg-12 text-center">
                <div class="pages-heading">
                      <h2> {{currentLang === 'ar' ? blog.TiteleAr : blog.TiteleEn }}  </h2>
          <ul class="list-unstyled mt-4 mb-0">
            <li class="list-inline-item h6 date text-muted"><i class="mdi mdi-calendar-check"></i> {{blog.createDate | date : 'dd/MM/yyyy'}} </li>
          </ul>
                </div>
            </div>  -->
        </div><!--end row-->
  <div class="position-breadcrumb">
      <nav aria-label="breadcrumb" class="d-inline-block">
        <ul class="breadcrumb rounded shadow mb-0 px-4 py-2">
          <li class="breadcrumb-item"><a routerLink="/">{{'Home' | translate}}</a></li>
          <li class="breadcrumb-item active" aria-current="page">{{'Services' | translate}}</li>
        </ul>
      </nav>
    </div>
    
    </div> <!--end container-->
</section><!--end section-->
<div class="position-relative">
    <div class="shape overflow-hidden text-color-white">
        <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
        </svg>
    </div>
</div>
<!-- Hero End -->

<!-- Start -->
<section class="section">
    <div class="container">
        <div class="row align-items-center" >
               <div class="col-lg-4 col-md-6" *ngFor="let service of ourservices">
                <div
                routerLink="/service-detail/{{service.Id}}"
                    class="card border-0 features feature-primary feature-clean course-feature p-4 overflow-hidden shadow">
                      <!-- <div class="icons text-center">
                        <i class="uil uil-heart d-block rounded h3 mb-0"></i>
                    </div> -->
                    <div class="icons text-center">
                       <img [src]="service.ImageUrl" [alt]="service.TitleEn" width="100px" class="img-fluid">
                    </div>
                    <div class="card-body p-0 mt-4">
                        <a href="javascript:void(0)" class="title h5 text-dark">{{ currentLang != 'ar' ? service.TitleEn : service.TitleAr }}</a>
                        <p class="text-muted mt-2">{{ currentLang != 'ar' ? service.DescriptionEn : service.DescriptionAr }}
                        </p>
                        <a routerLink="/service-detail/{{service.Id}}" class="read-more">{{'Read More' | translate}} 
                          <i class="uil uil-angle-right-b" *ngIf="currentLang == 'en'"></i>
                          
                          <i class="uil uil-angle-left-b" *ngIf="currentLang == 'ar'"></i>
                        </a>
                        <i class="uil uil-airplay full-img"></i>
                    </div>
                </div>
            </div><!--end col-->
        </div><!--end row-->
    </div><!--end container-->

  <div class="container mt-100 mt-60">
  <div class="row justify-content-center">
    <div class="col-12">
      <div class="section-title text-center mb-4 pb-2">
        <h6 class="text-primary">{{'Work Process' | translate}}</h6>
        <h4 class="title mb-4">{{'How do we work?' | translate}}</h4>
        <p class="text-muted para-desc mx-auto mb-0">
          {{'From pickup to delivery, ' | translate}}<span class="text-primary fw-bold">{{'Easy Wash' | translate}}</span>
          {{' takes care of every step so you get clean, fresh laundry without any hassle.' | translate}}
        </p>
      </div>
    </div><!--end col-->
  </div><!--end row-->

  <div class="row">
    <!-- Step 1: Pickup -->
    <div class="col-md-4 mt-4 pt-2">
        <div class="card features feature-primary feature-clean work-process bg-transparent  border-0 text-center"
      >
        <div class="icons text-center mx-auto">
          <i class="uil uil-box d-block rounded h3 mb-0"></i>
        </div>
        <div class="card-body">
          <h5 class="text-dark">{{'Pickup' | translate}}</h5>
          <p class="text-muted mb-0">
            {{'Schedule a pickup time that suits you, and our team collects your laundry directly from your doorstep.' | translate}}
          </p>
        </div>
      </div>
    </div><!--end col-->

    <!-- Step 2: Wash -->
    <div class="col-md-4 mt-md-5 pt-md-3 mt-4 pt-2">
  <div class="card features feature-primary feature-clean work-process bg-transparent  border-0 text-center">
        <div class="icons text-center mx-auto">
          <i class="uil uil-water-glass d-block rounded h3 mb-0"></i>
        </div>
        <div class="card-body">
          <h5 class="text-dark">{{'Wash' | translate}}</h5>
          <p class="text-muted mb-0">
            {{'Your clothes are professionally cleaned using high-quality equipment and safe, effective detergents.' | translate}}
          </p>
        </div>
      </div>
    </div><!--end col-->

    <!-- Step 3: Delivery -->
    <div class="col-md-4 mt-md-5 pt-md-5 mt-4 pt-2">
        <div class="card features feature-primary feature-clean work-process bg-transparent  border-0 text-center"
      >
        <div class="icons text-center mx-auto">
          <i class="uil uil-truck d-block rounded h3 mb-0"></i>
        </div>
        <div class="card-body">
          <h5 class="text-dark">{{'Delivery' | translate}}</h5>
          <p class="text-muted mb-0">
            {{'Fresh, clean, and neatly folded — your laundry is delivered back to you right on schedule.' | translate}}
          </p>
        </div>
      </div>
    </div><!--end col-->
  </div><!--end row-->
</div>
    <div class="container-fluid mt-100 mt-60">
        <div class="bg-cta shadow rounded card overflow-hidden"
            style="background: url('https://wpress.alaghr.sa/wp-content/uploads/2026/04/%D8%B4%D8%B3%D8%A8%D9%8A%D8%B4%D9%8A%D8%A8%D8%B4-3-scaled.png') center center;" id="cta">
            <div class="bg-overlay"></div>
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-12 text-center">
                        <div class="section-title">
                            <h4 class="title title-dark text-white mb-4"></h4>
                            <p class="text-white-50 para-dark para-desc mx-auto"></p>
                            <a href="http://youtube.com/shorts/qZSZVd_4C8Y?si=asBg6C1FLM2s9Nu7" class="play-btn mt-4 video-play-icon">
                                <i-feather name="play" class="fea icon-ex-md text-white title-dark"></i-feather>
                            </a>
                        </div>
                    </div><!--end col-->
                </div><!--end row-->
            </div><!--end container-->
        </div>
    </div><!--end container-->

</section>

<!--end section-->
<!-- End -->

<!-- Back to top -->
<a href="javascript: void(0);" class="btn btn-icon btn-primary back-to-top" id="back-to-top" [ngxScrollTo]="'#home'">
    <i-feather name="arrow-up" class="icons"></i-feather>
</a>